export const menuItems = [
    {
        id: 1,
        label: 'menuitems.dashboard.text',
        icon: 'bx-home-circle',
        link: '/',
    }
];

